import { useApiClient } from "@/hooks/useApiClient";
import useSWR from "swr";

export interface NewsSummary {
  id: number;
  title: string;
  category: string;
  publishedAt: string;
  pinned: boolean;
}

export interface NewsSummaryResponse {
  // NOTE: ピン留め分のみ。pinned_order昇順 → 公開日降順で並ぶ
  pinned: NewsSummary[];
  // NOTE: 全件（pinned=True/False両方）。公開日降順 → 同日内はpinned_order昇順（NULLは最後）で並ぶ
  all: NewsSummary[];
}

export interface NewsDetailResponse {
  id: number;
  title: string;
  category: string;
  publishedAt: string;
  tags: string[];
  detail: string;
  updatedAt: string;
}

export const NewsSummaryAPI = (year: number): NewsSummaryResponse => {
  const { apiClient } = useApiClient();
  const params = {
    year,
  };
  const url = "/news/";

  const fetcher = async (): Promise<NewsSummaryResponse> => {
    return (await apiClient.get<NewsSummaryResponse>(url, { params })).data;
  };
  const { data: newsSummaries } = useSWR({ url, params }, fetcher, {
    revalidateOnFocus: false,
  });

  return newsSummaries ?? { pinned: [], all: [] };
};

export const NewsDetailAPI = (id: number | null): NewsDetailResponse | null => {
  const { apiClient } = useApiClient();
  const url = "/news";

  const fetcher = async (): Promise<NewsDetailResponse> => {
    return (await apiClient.get<NewsDetailResponse>(`${url}/${String(id)}`))
      .data;
  };
  const { data } = useSWR(id !== null ? { url, id } : null, fetcher, {
    revalidateOnFocus: false,
  });

  return data ?? null;
};
